<template>
  <div id="app">
    <!-- 顶部环境蓝调微光层 -->
    <div class="tech-ambient-glow tech-glow-top"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>

    <!-- 底部环境蓝调微光层 -->
    <div class="tech-ambient-glow tech-glow-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1E293B;
  background-color: #F2F6FA;
  background-image: 
    radial-gradient(ellipse 90% 40% at 50% -5%, rgba(37, 117, 252, 0.08) 0%, rgba(242, 246, 250, 0.4) 60%, transparent 80%),
    linear-gradient(180deg, #F2F6FA 0%, #F6F9FC 40%, #EEF4FA 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 50px rgba(37, 117, 252, 0.06);
}

/* 顶部与底部极淡天蓝氛围漫射光 */
.tech-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(60px);
}

.tech-glow-top {
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 260px;
  background: radial-gradient(circle, rgba(37, 117, 252, 0.12) 0%, rgba(77, 146, 253, 0.05) 50%, transparent 75%);
}

.tech-glow-bottom {
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 240px;
  background: radial-gradient(circle, rgba(37, 117, 252, 0.08) 0%, rgba(14, 165, 233, 0.04) 50%, transparent 70%);
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
